import React from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'

import NextLevelBar from '../NextLevelBar'

function ReputationTooltip({
  currentLevel, nextLevel, royalties, currentRep, nextRep,
}) {
  return (
    <div className="reputation-tooltip">
      <div className="tooltip-title">
        {!nextLevel ? (
          <div className="tooltip-title">You're a <span className="tooltip-title__level">{currentLevel}</span></div>
        ) : (
          <div className="tooltip-title">Next level: <span className="tooltip-title__level">{nextLevel}</span></div>
        )}
      </div>
      <div className="tooltip-royalties">
        <div className="tooltip-royalties__rate">{numeral(royalties/100).format('0%')}</div>
        <div>Current earning rate</div>
      </div>
      {nextLevel
      && <NextLevelBar currentRep={currentRep} nextRep={nextRep} />}
    </div>
  )
}

ReputationTooltip.propTypes = {
  currentLevel: PropTypes.string.isRequired,
  nextLevel: PropTypes.string,
  royalties: PropTypes.number.isRequired,
  currentRep: PropTypes.number.isRequired,
  nextRep: PropTypes.number,
}

export default ReputationTooltip
